import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AboutCandidatesFetchFailedAction = {
	type: 'ABOUT_CANDIDATES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AboutCandidatesFetchFailedAction => ({
	type: 'ABOUT_CANDIDATES_FETCH_FAILED',
	payload,
});
